import TemplateGroup from "./models/TemplateGroup";
import { DeviceClasses } from "./models/DeviceClasses";
import { isUiModeDeveloper } from "./uiMode";
import { itx } from "./translationItx/itx";

export function createEmptyProject(state: any) {
  state.suppressUndoObservation = true;
  state.clear();
  if (isUiModeDeveloper()) {
    let templateGroupAll = new TemplateGroup(
      {
        name: itx("demoData.productFamily", "Produktfamilie"),
        tag: "00",
        templateGroupType: DeviceClasses.Unknown,
      },
      state.templateGroups,
    );
    state.templateGroups.add(templateGroupAll);
  }

  let templateGroupActors = new TemplateGroup(
    {
      name:
        itx("components.plural.Actor", "Aktoren") +
        " " +
        itx("&", "&") +
        " " +
        itx("components.CabinetElement", "Schaltschrankelemente"),
      tag: "01",
      templateGroupType: DeviceClasses.Actor,
    },
    state.templateGroups,
  );
  state.templateGroups.add(templateGroupActors);

  let templateGroupButtons = new TemplateGroup(
    { name: itx("components.plural.Button", "Tasten"), tag: "02", templateGroupType: DeviceClasses.Button },
    state.templateGroups,
  );
  state.templateGroups.add(templateGroupButtons);

  let templateGroupSensors = new TemplateGroup(
    {
      name: itx("components.plural.Sensor", "Sensoren"),
      tag: "03",
      templateGroupType: DeviceClasses.SensorNew,
    },
    state.templateGroups,
  );
  state.templateGroups.add(templateGroupSensors);

  state.templateGroups.add(
    new TemplateGroup(
      {
        name: itx("demoData.DecentralActor", "dezentrale Aktoren"),
        tag: "04",
        templateGroupType: DeviceClasses.DecentralActor,
      },
      state.templateGroups,
    ),
  );

  state.settings.loadDefaultCompanyLogo().then(() => {
    state.settings.calcCompanyLogoSize();
  });
  state.enableUndoMonitoring();
  state.suppressUndoObservation = false;
  state.undoManager.clear();
}
